import "./renderer.setup.ts";
import dayjs from "dayjs";
import React from "react";
import ReactDOM from "react-dom/client";
import "dayjs/locale/zh-cn";
import { setCreateRoot } from "@arco-design/web-react/es/_util/react-dom";
import "modern-normalize";
import "@arco-design/web-react/dist/css/arco.css";
import "@/styles/arco.over.css";
import "@/styles/app.css";
import { useUserStore } from "@/stores/userStore.ts";
import { Bridge } from "./lib/ipc/bridge.ts";
import { getBridge } from "./lib/ipc/util.ts";
import { storeName as appSettingsStoreName } from "./lib/store/appSettingsStore.init.ts";
import { storeName as userStoreName } from "./lib/store/userStore.init.ts";
import { useAppSettingsStore } from "./stores/appSettingsStore.ts";

setCreateRoot(ReactDOM.createRoot);

// 设置dayjs全局locale为中文
dayjs.locale("zh-cn");

const rootEl = document.getElementById("root");

if (rootEl) {
	const [userStoreStateR, appSettingsStoreStateR] = await Promise.allSettled(
		[userStoreName, appSettingsStoreName].map((x) => {
			return getBridge(Bridge.Store)?.getState?.(x);
		}),
	);

	if (userStoreStateR.status === "fulfilled" && userStoreStateR.value) {
		useUserStore.setState(userStoreStateR.value);
	}

	if (
		appSettingsStoreStateR.status === "fulfilled" &&
		appSettingsStoreStateR.value
	) {
		useAppSettingsStore.setState(appSettingsStoreStateR.value);
	}

	import("./App.tsx").then(({ App }) => {
		ReactDOM.createRoot(rootEl).render(
			<React.StrictMode>
				<App />
			</React.StrictMode>,
		);
	});
}
